export default __webpack_public_path__ + "static/media/Richard.32f94485.png";